import Layout from "../layouts/Layout";
import DashboardIcon from "@mui/icons-material/Dashboard";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import AddDestinationLocation from "../features/data-providers/add-destination-location/AddDestinationLocation";
import { Redirect1 } from "../features/duc/Redirect";
import { Redirect2 } from "../features/duc/Redirect";
import LockIcon from '@mui/icons-material/Lock';
import DataDownloadProcess from "../features/data-download/DataDownloadProcess";
import DUCpage from "../features/duc/DUCpage";
import DUCProcess from "../features/duc/DUCProcess";
import DataWrangler from "../features/new-data-wrangler/DataWrangler";
import HelpCenterPage from "../features/help-center/HelpCenterPage";
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import GlobusRedirect from "../features/globus/components/GlobusRedirect";
import FeedIcon from '@mui/icons-material/Feed';
import Publications from "../features/publications/Publications";
import NewPublication from "../features/publications/NewPublication";
import TrainingProcess from "../features/duc/TrainingProcess";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import GlobusController from '../features/globus-collections/GlobusController';
import PIDashboard from "../features/duc/PIDashboard";
import { Roles } from "./Roles";
import VideosPage from "../features/help-center/VideosPage";
import DownloadToolsPage from "../features/download-tools/DownloadToolsPage";
import DownloadIcon from '@mui/icons-material/Download';
import CliInstructions from "../features/download-tools/CliInstructions";
import UserAccountsLayout from "../features/user-accounts/components/UserAccountsLayout";
import VariableBreakdown from "../features/dashboard/components/QcDashboards/VariableBreakdown";
import VpnLockIcon from '@mui/icons-material/VpnLock';
import DashboardLayout from "../features/dashboard/components/DashboardLayout";
import ExploreLayout from "../features/dashboard/components/ExploreLayout";
import ResearchDomains from "../features/dashboard/components/ResearchDomains";
import CohortDemographics from "../features/dashboard/components/CohortDemographics";
import DomainFilterLayout from "../features/dashboard/components/DomainFilterLayout";
import ByVisits from "../features/dashboard/components/ByVisits";

export const getPages = (onlyDuc: boolean): any[] => {
    return [
        {
            type: "path",
            element: Redirect1,
            path: "accounts/ducprocess/redirect",
        },
        {
            type: "path",
            element: Redirect2,
            path: "accounts/ducprocess/redirect2",
        },
        {
            type: "path",
            element: GlobusRedirect,
            path: "globus-redirect"
        },
        {
            type: "layout",
            element: Layout,
            disableWithKeycloak: false,
            children:
            [
                {
                    type: "layout",
                    element: DashboardLayout,
                    children: [
                        {
                            type: "layout",
                            element: ExploreLayout,
                            children:
                                [
                                    {
                                        type: "index",
                                        element: CohortDemographics,
                                        sidebar: {
                                            label: "Dashboard",
                                            icon: DashboardIcon,
                                        },
                                        public: true
                                    },
                                    {
                                        type: "layout",
                                        element: DomainFilterLayout,
                                        children: [
                                            {
                                                type: "path",
                                                element: ResearchDomains,
                                                requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT"] as Roles[],
                                                path: "by-domain",
                                            },
                                            {
                                                type: "path",
                                                element: ByVisits,
                                                requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT"] as Roles[],
                                                path: "by-visit",
                                            }
                                        ]
                                    }
                                ]
                        },
                        {
                            type: "path",
                            element: VariableBreakdown,
                            requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT"] as Roles[],
                            path: "by-domain/:instrument",
                        },
                    ]
                },
                {
                    type: "path",
                    element: DataWrangler,
                    path: "data-wrangler",
                    sidebar: {
                        // Hack for LC-2598 to rename sidebar label if you're not logged in
                        label: (user: any) => user.id === -1 ? "Data Dictionary" : "All Study Data Search & Filter",
                        icon: QueryStatsIcon },
                    public: true
                },
                {
                    type: "path",
                    element: DownloadToolsPage,
                    requiredRoles: ["ADMIN", "SUBJECT", "DUCREQUIRED", "TRAININGREQUIRED"] as Roles[],
                    sidebar: {
                        label: "Download Tools", icon: DownloadIcon,
                    },
                    path: "download-tools",
                },
                {
                    type: "path",
                    element: Publications,
                    requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT"] as Roles[],
                    path: "publications",
                    disabled: onlyDuc,
                    sidebar: { label: "NBDC Publications", icon: FeedIcon },
                },
                {
                    type: "path",
                    element: UserAccountsLayout,
                    requiredRoles: ["ExternalAdmin"] as Roles[],
                    path: "user-accounts",
                    sidebar: {
                        label: "Study Admin Dashboard",
                        icon: PeopleAltIcon,
                    },
                },
                {
                    type: "path",
                    element: DUCpage,
                    requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT", "DUCREQUIRED", "TRAININGREQUIRED"] as Roles[],
                    path: "duc",
                    sidebar: { label: "Data Access (DUC)", icon: LockIcon },
                },
                {
                    type: "path",
                    element: HelpCenterPage,
                    requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT", "DUCREQUIRED", "TRAININGREQUIRED"] as Roles[],
                    path: "help-center",
                    disabled: onlyDuc,
                    sidebar: { label: "Help Center", icon: BookmarksIcon },
                },
                {
                    type: "path",
                    element: VideosPage,
                    requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT", "DUCREQUIRED", "TRAININGREQUIRED"] as Roles[],
                    path: "help-center/videos",
                    disabled: onlyDuc
                },
                {
                    type: "path",
                    element: DUCProcess,
                    requiredRoles: ["ADMIN", "SUBJECT", "DUCREQUIRED", "TRAININGREQUIRED"] as Roles[],
                    path: "duc/request",
                },
                {
                    type: "path",
                    element: PIDashboard,
                    requiredRoles: ["ADMIN", "PI"] as Roles[],
                    excludedRoles: ["DUCREQUIRED", "TRAININGREQUIRED"] as Roles[],
                    path: "duc/sub-applicants",
                },
                {
                    type: "path",
                    element: AddDestinationLocation,
                    requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT"] as Roles[],
                    path: "file-download/add",
                },
                {
                    type: "path",
                    element: DataDownloadProcess,
                    requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT"] as Roles[],
                    path: "data-download/new",
                    disabled: onlyDuc
                },
                {
                    type: "path",
                    element: NewPublication,
                    requiredRoles: ["ADMIN", "SUBMISSION", "SUBJECT"] as Roles[],
                    path: "publications/add",
                    disabled: onlyDuc
                },
                {
                    type: "path",
                    element: TrainingProcess,
                    requiredRoles: ["ADMIN", "SUBJECT", "SUBMISSION", "TRAININGREQUIRED"] as Roles[],
                    path: "duc/training",
                },
                {
                    type: "path",
                    element: GlobusController,
                    requiredRoles: ["ADMIN", "SUBJECT", "TRAININGREQUIRED"] as Roles[],
                    path: "globus-collections",
                    disabled: onlyDuc
                },
                (window.env?.openOnDemandURL ?
                    {
                        type: "link",
                        path: window.env.openOnDemandURL,
                        requiredRoles: ["ADMIN", "SUBJECT", "SUBMISSION"] as Roles[],
                        sidebar: {
                            label: "Lasso SAFE",
                            icon: VpnLockIcon,
                            hoverTooltip: "Lasso SAFE analyze your tabulated data using R or Jupyter."
                        }
                    }
                    : {}
                ),
                {
                    type: "path",
                    element: CliInstructions,
                    requiredRoles: ["ADMIN", "SUBJECT", "TRAININGREQUIRED"] as Roles[],
                    path: "download-tools/cli",
                    disabled: onlyDuc
                },
            ],
        },
    ];
};
